import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ColorData from "Components/CstmTheme/ColorData";
import ImgPath from "Constants/Imgs";

type SidebarDrawerProps = {
  open: boolean;
  onClose: () => void;
  navItems: {
    label: string;
    path: string;
    inactiveIcon: any;
    activeIcon: any;
    roles?: string[];
  }[];
  handleLogout?: () => void;
};
// Optional: define animation duration if needed
const animationDuration = 200;

const SidebarDrawer: React.FC<SidebarDrawerProps> = ({
  open,
  onClose,
  navItems,
  handleLogout,
}) => {
  const [activeItem, setActiveItem] = useState("Dashboard");
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleItemClick = (label: string, path: string) => {
    if (label === "Logout") {
      handleLogout?.();
    } else {
      setActiveItem(label);
      onClose?.();

      // If it's an external path or .html page, do full redirect
      if (path?.endsWith(".html") || path?.startsWith("http")) {
        window.location.href = path;
      } else {
        navigate(path);
      }
    }
  };
  const DrawerList = (
    <Box
      sx={{
        width: 280,
        background: "linear-gradient(180deg, #283165 0%, #1c234b 100%)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxShadow: "10px 0 30px rgba(0,0,0,0.1)",
      }}
      onClick={onClose}
    >
      <Box
        sx={{
          p: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
          mb: 2
        }}
      >
        <img
          src={"https://nolegalpaisa.com/assets/images/new_logo.webp"}
          alt="Logo"
          style={{
            objectFit: "contain",
            width: "100%",
            maxWidth: 180,
            height: "auto",
            cursor: "pointer",
            filter: "brightness(0) invert(1)", // Makes logo white for dark background
          }}
          onClick={() => (window.location.href = "/home.html")}
        />
      </Box>
      <List sx={{ px: 2, flex: 1, overflowY: "auto" }}>
        {navItems.map(({ label, inactiveIcon, activeIcon, path }, index) => {
          const isActive = label === activeItem;
          const isHovered = label === hoveredItem;
          return (
            <ListItem key={label} disablePadding>
              <ListItemButton
                onClick={() => handleItemClick(label, path)}
                onMouseEnter={() => setHoveredItem(label)}
                onMouseLeave={() => setHoveredItem(null)}
                sx={{
                  borderRadius: "12px",
                  mb: 1,
                  px: 2,
                  py: 1.5,
                  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                  bgcolor: isActive ? "rgba(255, 255, 255, 0.12)" : "transparent",
                  border: isActive ? "1px solid rgba(255, 255, 255, 0.2)" : "1px solid transparent",
                  "&:hover": {
                    bgcolor: "rgba(255, 255, 255, 0.08)",
                    transform: "translateX(4px)",
                  },
                }}
              >
                <ListItemIcon sx={{ 
                  minWidth: 40, 
                  color: isActive ? "#4fc3f7" : "rgba(255,255,255,0.7)",
                  ".MuiSvgIcon-root": { fontSize: 22 }
                }}>
                  {isActive ? activeIcon : inactiveIcon}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        fontFamily: '"Outfit", sans-serif',
                        fontSize: "0.98rem",
                        fontWeight: isActive ? 600 : 400,
                        color: isActive ? "#ffffff" : "rgba(255,255,255,0.8)",
                      }}
                    >
                      {label}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      {/* Optional: Add a subtle footer or version info here if needed */}
    </Box>
  );

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      {/* Drawer content goes here */}
      {DrawerList}
    </Drawer>
  );
};

export default SidebarDrawer;
